import glamorous from 'glamorous';
import themes from "../../themes"

const HomeStyled = glamorous.div({
    display: "flex", 
    flexDirection: "flex-Start",
    fontFamily: "Tajawal",
    minHeight: "100vh",
},
    props => {
        if (props.theme === "dark") {
            return { backgroundColor: themes[0].base, color: themes[0].text}
        }
        else {
            return { backgroundColor: themes[1].base, color: themes[1].text}
        }
    }
)

export default HomeStyled



// WEBPACK FOOTER //
// ./src/containers/home/HomeStyled.js